type QuotationCommercialSource = {
  terms?: string | null
  termsOfPayment?: string | null
  terms_of_payment?: string | null
  paymentTerms?: string | null
  remittanceInstructions?: string | null
  remittance_instructions?: string | null
  remittanceDetails?: string | null
  bankDetails?: string | null
}

const cleanValue = (value?: string | null): string => {
  const normalized = String(value ?? '').trim()
  return normalized
}

export const resolveQuotationTermsOfPayment = (
  quotation?: QuotationCommercialSource | null
): string => {
  return cleanValue(
    quotation?.termsOfPayment ??
      quotation?.terms_of_payment ??
      quotation?.paymentTerms ??
      ''
  )
}

export const resolveQuotationRemittanceInstructions = (
  quotation?: QuotationCommercialSource | null
): string => {
  return cleanValue(
    quotation?.remittanceInstructions ??
      quotation?.remittance_instructions ??
      quotation?.remittanceDetails ??
      quotation?.bankDetails ??
      ''
  )
}

export const normalizeQuotationCommercialFields = <T extends QuotationCommercialSource>(
  quotation: T
) => ({
  ...quotation,
  terms: cleanValue(quotation?.terms ?? ''),
  termsOfPayment: resolveQuotationTermsOfPayment(quotation),
  remittanceInstructions: resolveQuotationRemittanceInstructions(quotation),
})
